import request from '../../axios';

export const getListLoanType = async (isDirect?: boolean) => {
  const {data}: {data: ILoanType[]} = await request.get(
    `/api/v2/payment/list-loan-type`,
    {
      params: {
        is_direct: isDirect,
      },
    },
  );

  return data;
};
